import Reflux from 'reflux';
import EventData from 'shared/data/Event';
// import readOnlyHelper from 'flux/helpers/readOnlyHelper';

// const readOnlyCfg = readOnlyHelper.actionConfigFactory();

let async = { asyncResult: true },
  EventListActions = Reflux.createActions({
    toggleEdit: {},
    cancelEdit: {},
    duplicate: async,
    softDelete: async,
    restore: async,
    //,
    //"savePhoto": readOnlyCfg
  });

EventListActions.duplicate.listenAndPromise(
  EventData.duplicate.bind(EventData),
);
EventListActions.softDelete.listenAndPromise(
  EventData.softDelete.bind(EventData),
);
EventListActions.restore.listenAndPromise(EventData.restore);

export default EventListActions;
